<template>
  <v-container :fluid="true" class="page_container">
    <div class="event__title">
      <span class="event__title--text" v-if="getEventsDetail !== null && !isLoading">
        Событие от партнера: {{ getEventsDetail.partner_info.name }}
      </span>
      <v-btn
        v-if="getEventsDetail === null || getEventsDetail.is_registration_available && !getEventsDetail.iam_participants"
        :color="'#376FFE'"
        elevation="0"
        variant="flat"
        class="filter-btn"
        @click.stop="modal.register = true"
      >
        Записаться
      </v-btn>
      <v-btn
        v-else-if="getEventsDetail === null || getEventsDetail.is_registration_available && getEventsDetail.iam_participants"
        color="#FFC538"
        elevation="0"
        variant="flat"
        class="filter-btn"
        style="color: black"
        @click.stop="modal.cancel = true"
      >
        Отменить<v-icon v-if="getEventsDetail === null || getEventsDetail.is_registration_available" style="color: red" size="16px">history_2</v-icon>
      </v-btn>
    </div>
    <div class="event__container" v-if="getEventsDetail !== null && !isLoading">
      <div class="event__top_name">
        {{ getEventsDetail.title }}
      </div>
      <div
          class="event__back"
          @click.stop="returnParent"
      >
        <v-icon size="24" class="font-weight-bold">west</v-icon>
      </div>
      <v-row no-gutters class="mt-10 mb-5" justify="start" v-if="$vuetify.display.width > 1596">
        <div v-for="(item, i) in getEventsDetail.tags" :key="i">
          <v-btn color="#376FFE" variant="flat" class="filter-btn" :active="false">{{item.name}}</v-btn>
        </div>
      </v-row>
      <v-row class="event__text event__text--before">
        <v-col>
          Мест занято: <strong>{{ getEventsDetail.participants.registered }}/{{ getEventsDetail.max_participants }}</strong>, в листе ожидания: <strong>{{ getEventsDetail.participants.waited }}</strong>.
        </v-col>
        <v-col>
          Дата события: <strong>{{ convertDate(getEventsDetail.event_date) }}</strong>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <div class="event__text">
        <span v-html="getEventsDetail.full_description">
        </span>
      </div>
      <v-row justify="end" >
        <v-btn color="#376FFE" variant="flat" class="filter-btn" v-if="getEventsDetail === null || !getEventsDetail.is_registration_available">Записаться</v-btn>
      </v-row>
    </div>
    <div v-else-if="getEventsDetail === null && !isLoading">
      <NoData/>
    </div>
    <div class="event__container" v-else>
      <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
        <fulfilling-square-spinner
            :animation-duration="4000"
            :size="100"
            color="#34347C"
        />
      </v-row>
    </div>
    <user-register-application
      v-model="modal.register"
      :event_id="getEventsDetail.id"
      v-if="getEventsDetail !== null && getEventsDetail.is_registration_available"
      @save="registerToEvent($event, 'register')"
      @close="closeRegisterToEvent('register')"
    ></user-register-application>
    <user-cancel-register-application
      v-model="modal.cancel"
      :event_id="getEventsDetail.id"
      :app_id="getEventsDetail.iam_participant_id"
      v-if="getEventsDetail !== null && getEventsDetail.is_registration_available"
      @save="registerToEvent($event, 'cancel')"
      @close="closeRegisterToEvent('cancel')"
    ></user-cancel-register-application>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"
import { FulfillingSquareSpinner } from "epic-spinners"
import helper from "@/urls/helper"
import NoData from "@/modules/templates/NoData.vue"
import moment from "moment/moment"
import UserRegisterApplication from "@/modules/personal_account/calendar/modals/UserRegisterApplication.vue"
import UserCancelRegisterApplication
  from "@/modules/personal_account/calendar/modals/UserCancelRegisterApplication.vue"

export default defineComponent({
  name: "EventsDetail",
  components: {
    UserCancelRegisterApplication,
    UserRegisterApplication,
    NoData,
    FulfillingSquareSpinner
  },
  data () {
    return {
      isLoading: true,
      modal: {
        register: false,
        cancel: false
      }
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getEventsDetail: 'personal_account/events/getEventsDetail'
    }),
  },
  methods: {
    ...mapActions({
      loadEventsDetail: 'personal_account/events/loadEventsDetail',
    }),
    convertDate (value) {
      return moment(value).format('YYYY-MM-DD HH:MM')
    },
    checkLink (str) {
      // eslint-disable-next-line
      const REGEXP_LINK = /\b((?:https?:\/\/|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'\".,<>?«»“”‘’]))|(\[[^\]]+\([^\)]+\))/gmi
      const REGEXP_HTML_A = /<a.*?>.*?<\/a.*?>/si
      const regexLink = new RegExp(REGEXP_LINK)
      const regexLinkTag = new RegExp(REGEXP_HTML_A)
      const matches = str.match(regexLinkTag)
      if (matches !== null) {
        return str
      }
      let link = str
      link = link.replace(regexLink, (match, offset) => {
        return "<a href=" + offset + " target='_blank'" + ">" + offset + "</a>"
      })
      return link
    },
    getFileLink (url) {
      return helper.getMendeleevUrlWithParameters(url.basename, url.action, url.params, null)
    },
    returnParent () {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.$router.push({ name: names.CALENDAR.PAGE })
    },
    loadData (url = undefined) {
      this.loadEventsDetail({
        id: this.$route.params.id,
        finalizer: () => {
          this.isLoading = false
        },
        catcher: () => {}
      })
    },
    registerToEvent (ev, modal) {
      this.$emit('singup', ev)
      this.modal[modal] = false
      this.loadData()
    },
    closeRegisterToEvent (modal) {
      this.modal[modal] = false
      this.loadData()
    }
  },
  beforeMount () {
    if (window.scrollY !== 0) {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    }
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({ name: names.MAIN })
    } else {
      this.loadData()
    }
  }
})
</script>

<style scoped lang="scss">
.event__title {
  display: flex;
  justify-content: space-between;
}

.event__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.event__container {
  position: relative;
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
  padding: 50px;
}

.event__content {
  display: flex;
  position: relative;
}

.event__top_name {
  content: "";
  display: inline-flex;
  position: absolute;
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  padding: 0 50px;
  max-width: 70%;
  height: 50px;
  background-color: #3254B9;
  border-radius: 5px 0;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
}

.event__back {
  content: "";
  display: inline-flex;
  position: absolute;
  right: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background: #376FFE;
  border-radius: 5px;
  cursor: pointer;
}

.event__logo {
  display: inline-flex;
  align-content: center;
  justify-content: center;
  margin-top: 50px;
}

.event__text {
  margin-top: 50px;
  font-style: normal;
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
  overflow: hidden;

  &--before {
    margin-top: 15px;
  }
}

@media screen and (max-width: 768px) {
  .event__title {
    margin-top: 20px;
  }

  .event__container {
    padding: 20px;
  }

  .event__top_name {
    font-size: 16px;
    line-height: 19px;
    padding: 10px 20px;
    min-height: 50px;
    height: inherit;
  }

  .event__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }
}
</style>
